import { useLiveQuery } from 'dexie-react-hooks';

import { aircraft, settings, tracks } from '@/lib/db';

/** Written when the first-run guide is closed; see `WelcomeDialog`. */
export const WELCOME_SEEN_KEY = 'onboarding.welcomeSeen';

/**
 * `true` once the first-run guide should show, `false` if not, `null` while the
 * database is still opening.
 *
 * Exported for the root layout, which uses it to tell a first run from every
 * later launch: the storage notice leaves backup out of a first run (nothing
 * is stored yet, and its Back up link would have opened Settings with this
 * guide landing on top of it).
 */
export function useShouldShowWelcome(): boolean | null {
  return useLiveQuery(
    async () => {
      const seen = await settings.get(WELCOME_SEEN_KEY, false);
      if (seen) {
        return false;
      }
      const [aircraftCount, trackCount] = await Promise.all([aircraft.count(), tracks.count()]);
      return aircraftCount === 0 && trackCount === 0;
    },
    [],
    null,
  );
}
